export const printmode = {
  printmodeHeader: 'Printmodes | One printmode | {n} printmodes',
  printmodeMethodHeader: 'Methods | Method | {n} methods',
  printmodeMaterialHeader: 'Materials | Material | {n} materials',
  actions: {
    createNew: 'Create new',
    update: 'Save'
  },
  name: 'Name',
  basicFeatures: 'Basic Features',
  description: 'Description',
  surfaceQuality: 'Surface Quality',
  applications: 'Applications',
  ranking: 'Ranking',
  rankingLabels: {
    price: 'Price',
    flexibility: 'Flexibility',
    stability: 'Stability',
    precision: 'Precision',
    wearResistance: 'Wear Resistance',
    heatResistance: 'Heat Resistance'
  },
  technicalFeatures: 'Technical Features',
  technicalFeaturesLabels: {
    resolutionXY: 'Resolution X & Y',
    resolutionZ: 'Resolution Z',
    minFeatureSize: 'Minimal Feature Size',
    maxNumberOfParts: 'Maximum Number of Parts',
    maxDimensions: 'Maximum Dimensions',
    maxDimensionLabels: {
      x: 'X',
      y: 'Y',
      z: 'Z'
    },
    maxIncrementalMeasurement: 'Max Incremental Measurement'
  },
  color: 'Color',
  chooseColor: 'Choose color',
  availableColors: 'Colors',
  availableSurfaceFinishes: 'Finishes',
  colorLabels: {
    name: 'Name of Color',
    variableName: 'Spreadsheet variable',
    hue: 'Hue',
    hexcode: 'Match a color Hexcode',
    thumbnail: 'Thumbnail',
    choose: 'Choose',
    create: 'Create new',
    delete: 'Delete',
    uploadImage: 'Upload Image',
    replaceImage: 'Replace Image'
  },
  material: 'Material',
  materialLabels: { choose: 'Choose material', createMaterial: 'Create material', create: 'Create' },
  method: 'Method',
  methodLabels: { choose: 'Choose method', createMethod: 'Create Method', create: 'Create' },
  whiteLabels: 'White Labels',
  whiteLabelLabels: {
    choose: 'Choose which labels can user this print-mode',
    createWhiteLabel: 'Create White Label',
    create: 'Create'
  },
  processingSteps: {
    header: 'Processing steps',
    choose: 'Choose which processing steps are available for this print-mode'
  },
  testPricing: 'Pricing',
  testPricingLabels: {
    test: 'Calculate Prices',
    paramLabels: {
      params: 'Test Parameters',
      dimensionX: 'Dimension X',
      dimensionY: 'Dimension Y',
      dimensionZ: 'Dimension Z',
      internalVolume: 'Volume',
      externalVolume: 'External Volume',
      surfaceArea: 'Surface Area',
      minX: 'Minimal X',
      maxX: 'Maximum X',
      maxY: 'Maximum Y'
    }
  },
  spreadSheetLabels: {
    defaultWhiteLabelName: 'Standard',
    upload: 'Upload spreadsheet',
    replace: 'Replace spreadsheet',
    delete: 'Delete',
    calculatedPrice: 'Calculated price',
    commission: "Commission",
    standardPrice: 'As standard',
    asStandard: 'As standard',
    isPrintable: 'Is printable',
    isNotPrintable: 'not printable',
    isTooSmall: 'Object too small',
    isTooLarge: 'Object too large',
    productionTime: 'Production Time',
    productionTimeDays: '0 days | 1 day | {n} days',
    spreadSheetMissing: 'No default spreadsheet uploaded',
    confirmDeleteHeadline: 'Deleting spreadsheet',
    confirmDeleteMessage:
      'Are you sure you want to <strong>delete</strong> this spreadsheet?<br>This action cannot be undone.',
    cancel: 'Cancel'
  }
};
